import React, { Component, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/AddBox";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ManageTemplate from "./manage_template";
import MetricDrawer from "./metricDrawer";
import DataService from "../../../../../Service";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  makeStyles,
  Button,
  TextField,
  InputAdornment,
  Tooltip,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import { Autocomplete } from "@material-ui/lab";
import SetupAutoComplete from "../SetupAutoComplete";

const useStyles = makeStyles((theme) => ({
  org_table: {
    "& tr th": {
      fontWeight: "700",
      // color: "#EF7000"
    },
  },
  buttonShadow: {
    textTransform: "inherit",
  },
  textSecondary: {
    color: theme.palette.secondary.main,
  },
  miTablebox: {
    "& .MuiFormControl-root": {
      width: "25%",
    },
  },
}));
export default function OrgansationalMetric() {
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [moduleSetups, setModuleSetups] = useState([]);
  const [action, setAction] = useState("");
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [openPopover, setPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const orgmetricValues = moduleSetups.map((el) => el.name);
  const desValues = moduleSetups.map((el) => el.description);
  const dropdownValue = orgmetricValues.concat(desValues);
  const uniqueArray = [
    ...new Set(dropdownValue.filter((value) => value !== null)),
  ];

  const moduleSetup = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search: searchText || null,
    };
    DataService.getDirectData(`/organisation_metrics`, params).then((res) => {
      console.log(`res`, res);
      setTotalCount(res["total_count"]);
      var localArr = [];
      res["data"].map((option) =>
        localArr.push({
          name: option.attributes.name,
          description: option.attributes.description,
          id: option.attributes.id,
        })
      );
      setLoading(false);
      setModuleSetups(localArr);
      setAction("");
    });
    // BookingsApiClient.getData(`/admin_users/payments?download=true`,params).then((res)=>{
    //     let downloadPayments = res['payments'];
    //     setDownloadPayments(downloadPayments)
    // })
  };
  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };
  useEffect(() => {
    setLoading(true);
    moduleSetup();
  }, [page, pageSize, searchText]);
  const [inputValue, setInputValue] = useState("");
  const searchSelectHandler = (option) => {
    setSearchText(option);
    setPage(0);
  };
  return (
    <div className={classes.miTablebox}>
      <SetupAutoComplete
        type="organisation_metrics"
        searchSelectHandler={searchSelectHandler}
      />

      <MaterialTable
        title=""
        className={classes.org_table}
        options={{
          actionsColumnIndex: -1,
          search: false,
          searchFieldAlignment: "left",
          pageSize: pageSize,
          emptyRowsWhenPaging: false,
          headerStyle: {
            fontWeight: 700,
            color: "#077F83",
            position: "sticky",
            top: "0",
          },
          maxBodyHeight: "600px",
          pageSizeOptions: [20, 50, 75, 100],
        }}
        columns={[
          {
            title: "Organizational metrics",
            field: "name",
            customSort: (a, b) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            },
          },
          {
            title: "Description",
            field: "description",
            customSort: (a, b) => {
              const nameA = a.description.toLowerCase();
              const nameB = b.description.toLowerCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            },
          },
        ]}
        data={moduleSetups}
        // onSearchChange={(search) => {
        //   setSearchText(search);
        // }}
        onChangePage={(page) => {
          setPage(page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          setPageSize(pageSize);
        }}
        actions={[
          {
            icon: () => <EditIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="Edit" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setAction("edit");
            },
          },
          {
            icon: () => <VisibilityIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="View" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setAction("View");
              window.document.getElementById("root")?.scrollIntoView(true);
            },
          },
          {
            icon: () => <DeleteIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="Delete" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setAction("delete");
            },
          },
          {
            icon: () => (
              <Button
                className={classes.buttonShadow}
                variant="contained"
                color="secondary"
              >
                + New organizational metrics
              </Button>
            ),
            isFreeAction: true,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setAction("create");
            },
          },
        ]}
      />
      {action && action != "View" && action != "create" && (
        <ManageTemplate
          action={action}
          moduleId={currentSelection?.id}
          moduleSetup={moduleSetup}
          data={currentSelection}
          handleClose={handleClose}
        />
      )}
      {action && action == "View" && (
        <MetricDrawer parentCall={setAction} moduleId={currentSelection?.id} />
      )}
      {action && action == "create" && (
        <ManageTemplate
          action={action}
          moduleSetup={moduleSetup}
          handleClose={handleClose}
        />
      )}
    </div>
  );
}
